import { ThemeInterface } from '@westwing/ui-kit/Theme';
import styled, { ThemeProps } from 'styled-components';
import { fromBreakpoint, TABLET } from '../../../../mediaqueries';

interface OverlayProps extends ThemeProps<ThemeInterface> {
    backgroundColor?: string;
    isLogin?: boolean;
    isBig?: boolean;
    isShifted?: boolean;
}
export const Overlay = styled.div<OverlayProps>`
    position: relative;
    margin: 0 5px;
    margin-top: ${(props: OverlayProps) => (props.isBig ? '55px' : '0px')};
    background: ${(props: OverlayProps) => (props.backgroundColor ? props.backgroundColor : props.theme.colors.white)};
    max-width: 335px;
    min-width: 280px;
    overflow: visible;
    width: 90%;

    ${(props: OverlayProps) => fromBreakpoint[TABLET]`
        position: relative;
        bottom: auto;
        max-width: none;
        width: ${props.isBig && !props.isLogin ? '474px' : '390px'};
        left: ${props.isShifted && !props.isLogin ? '-237px' : 'auto'}
    `}
`;
